import { RarityChip } from './RarityChip';
import { RarityGlow } from './RarityGlow';

type Props = {
  badgeName: string | null | undefined;
  /** Off when the card underneath is the opening scene's: this layer sits
   *  above the scene, so the glow would wash over its card. */
  hasGlow?: boolean;
};

/**
 * Sleek's rarity marks for the card frame they are placed in (partner Figma
 * 2026-10-08): the chip 16px above the frame and the glow behind it. Shared
 * by the reveal's winner and the Vault card page, so both screens show them
 * at one spot.
 */
export function SleekRarityMarks({ badgeName, hasGlow = true }: Props) {
  return (
    <>
      {hasGlow && <RarityGlow badgeName={badgeName} />}
      <div className="absolute inset-x-0 bottom-full flex justify-center pb-4">
        <RarityChip badgeName={badgeName} />
      </div>
    </>
  );
}
